export default __webpack_public_path__ + "static/date-label-do-2-light-a0db94cb4d253820af2c1676f38b4be7.png";